import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'

export interface WhoWeAreCardProps {
  title: string
  description: any
  icon: IconName
  iconPrefix: IconPrefix
}

export const useWhoWeAreCard = (props: WhoWeAreCardProps) => {
  return {
    ...props,
  }
}
